"use client"
import { Box, Typography, Button, Container, Grid, useMediaQuery, useTheme } from "@mui/material"
import { styled } from "@mui/material/styles"
import aboutImage from "../../../assets/images/about.png"
import Animator from "../../../components/Aminator/Animator"

// Styled components
const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Monserrat, sans-serif",
  fontSize: "0.9rem",
  fontWeight: 500,
  color: "#333",
  textTransform: "uppercase",
  marginBottom: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  "&::before": {
    content: '""',
    width: "40px",
    height: "1px",
    backgroundColor: "#333",
    marginRight: theme.spacing(2),
    display: "inline-block",
  },
}))

const MainHeading = styled(Typography)(({ theme }) => ({
  fontFamily: "Monserrat, sans-serif",
  fontSize: "2.5rem",
  fontWeight: 700,
  color: "#333",
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
  },
}))

const ContactButton = styled(Button)(({ theme }) => ({
  borderColor: "#E25822",
  color: "#E25822",
  padding: theme.spacing(1.5, 4),
  borderRadius: "4px",
  textTransform: "none",
  marginTop: theme.spacing(8),
  "&:hover": {
    borderColor: "#c94d1b",
    backgroundColor: "#E25822",
    color: "#ffffff",
  },
}))

// Styled component for the image container
const ImageContainer = styled(Box)(({ theme }) => ({
  width: "653px",
  height: "593px",
  borderRadius: "24px",
  overflow: "hidden",
  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    height: "auto",
    aspectRatio: "653/593",
  },
}))

const AboutUsSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Container maxWidth="lg" sx={{ my: 8 }}>
      <Grid container spacing={6} alignItems="center" direction={isMobile ? "column-reverse" : "row"}>
        {/* Left side - Content */}
        <Grid item xs={12} md={6}>
          
          <Box>
            <Animator variant="fade" timeout={800} delay={200}>
            <SectionTitle variant="subtitle2">What we do</SectionTitle>
            </Animator>

            <Animator variant="slide" direction="right" timeout={800} delay={300}>
            <MainHeading variant="h2" component="h2">
              Bridging Talent & Business
            </MainHeading>
            </Animator>

            <Animator variant="fade" timeout={800} delay={400}>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Monserrat, sans-serif",
                color: "#555",
                lineHeight: 1.7,
                fontSize: "1rem",
              }}
            >
              We bring top-tier professionals and thriving businesses together . Whether you’re an employer seeking standout talent or a skilled professional ready for your next challenge—we will help you bring an end to your search.

            </Typography>
            </Animator>

            <Animator variant="fade" timeout={800} delay={500}>
            <ContactButton variant="outlined" onClick={() => window.location.href = "/talents/register"}>Contact Us</ContactButton>
          </Animator>
          </Box>
        </Grid>

        {/* Right side - Image */}
        <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
          <ImageContainer>
            <Animator
              
              delay={1000}
              timeout={500}
              variant="zoom"
            >
            <Box
              component="img"
              src={aboutImage}
              

              alt="Professional man in blue suit"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
            </Animator>
          </ImageContainer>
        </Grid>
      </Grid>
    </Container>
  )
}

export default AboutUsSection

